"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _dateHelper = require("../../helpers/dateHelper");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _numberFormatter = require("../../helpers/numberFormatter");
var _orderHelper = require("../../helpers/orderHelper");
require("./ConfirmBlockTradeModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('confirm-block-trade-modal');
var ConfirmBlockTradeModal = function ConfirmBlockTradeModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var formObj = props.formObj,
    selectedInstrument = props.selectedInstrument,
    isOpen = props.isOpen,
    close = props.close,
    confirmReport = props.confirmReport,
    feeSymbol = props.feeSymbol,
    orderTotal = props.orderTotal,
    useNewForm = props.useNewForm;
  var isBuySide = formObj.values.side === _orderEntryFormConstants.buyValue;
  var boughtProductSymbol = isBuySide ? selectedInstrument.Product1Symbol : selectedInstrument.Product2Symbol;
  var soldProductSymbol = isBuySide ? selectedInstrument.Product2Symbol : selectedInstrument.Product1Symbol;
  var items = [{
    label: t('Instrument'),
    text: "".concat(selectedInstrument.Symbol)
  }, {
    label: t('Counterparty'),
    text: "".concat(formObj.values.counterparty ? formObj.values.counterparty : '-')
  }, {
    label: t('Locked in'),
    text: "".concat(formObj.values.lockedIn ? t('Yes') : t('No'))
  }, {
    label: t(useNewForm ? 'Quantity' : 'Product Bought'),
    text: "".concat(formObj.values.quantity, " ").concat(useNewForm ? selectedInstrument.Product1Symbol : boughtProductSymbol)
  }, {
    label: t(useNewForm ? 'Price' : 'Product Sold'),
    text: "".concat(formObj.values.price, " ").concat(useNewForm ? selectedInstrument.Product2Symbol : soldProductSymbol)
  }, {
    label: t('Fee'),
    text: (0, _numberFormatter.formatNumberToLocale)(formObj.values.fee.OrderFee, feeSymbol)
  }, {
    label: t('Final Amount'),
    text: useNewForm ? "".concat(formObj.values.quantity) : (0, _orderHelper.getOrderNet)(formObj.values, selectedInstrument, orderTotal, false)
  }, {
    label: t('Final Value'),
    text: (0, _numberFormatter.formatNumberToLocale)(useNewForm ? formObj.values.price * formObj.values.quantity : formObj.values.price, soldProductSymbol)
  }];
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t('Confirm Block Trade'),
    close: close,
    footer: {
      buttonText: isBuySide ? t('Confirm Buy Order') : t('Confirm Sell Order'),
      buttonStyle: isBuySide ? 'additive' : 'subtractive',
      onClick: function onClick() {
        return confirmReport(formObj.values);
      }
    },
    customClass: bemClasses(formObj.values.side === _orderEntryFormConstants.buyValue ? 'bought' : 'sold')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
      key: item.label,
      label: item.label,
      text: item.text,
      customClass: bemClasses()
    });
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(t('Date'), ":"),
    text: (0, _dateHelper.formatDateTime)(new Date()),
    customClass: bemClasses()
  })));
};
ConfirmBlockTradeModal.propTypes = {
  formObj: _propTypes["default"].object.isRequired,
  selectedInstrument: _propTypes["default"].object.isRequired,
  close: _propTypes["default"].func.isRequired,
  confirmReport: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ConfirmBlockTradeModal;